<mat-toolbar color="primary" class="custom-header">
  <button mat-icon-button (click)="guiService.goTo('main/diary')">
    <mat-icon svgIcon="mat:chevron_left"></mat-icon>
  </button>
</mat-toolbar>
<div class="container" *ngIf="guiService.userLogged.workoutInfo.lastWorkoutHistory && !workoutNameLoader">
  <h2 class="workout-history-title">{{"DIARY.WORKOUT-HISTORY" | translate}}</h2>
  <div class="last-workout-container" *ngFor="let workout of guiService.userLogged.workoutInfo.lastWorkoutHistory; let i = index">
    <div class="last-workout last-workout-tutorial" [class]="guiService.evaluateBgColor(i)">
      <p>{{getProgramName(workout.idProgram)[translate.currentLang.toUpperCase()]}}</p>
      <p class="workout-name">{{mapNames[workout.workoutId][translate.currentLang.toUpperCase()]}}</p>
      <p>{{"DIARY.WEEK" | translate}} {{workout.week}} · {{"DIARY.DAY" | translate}} {{workout.day}}</p>
      <p class="date">{{workout.executionDate | date: guiService.dateFormat}}</p>
      <img class="workout-img" [src]="environment.workouts+'/'+workout.workoutId+'/images/main'">
    </div>
    <div class="workout-status">
      <div class="line" *ngIf="i > 0"></div>
      <mat-icon svgIcon="mat:pause" *ngIf="workout.status === 'PAUSED'"></mat-icon>
      <img *ngIf="workout.status !== 'PAUSED'" src="../../assets/img/thunderbolt_violet.svg" alt="">
      <p>{{"GENERIC."+workout.status | translate}}</p>
    </div>
  </div>
</div>
<div class="container" *ngIf="guiService.userLogged.workoutInfo.lastWorkoutHistory && workoutNameLoader">
  <h2>{{"DIARY.WORKOUT-HISTORY" | translate}}</h2>
  <div class="last-workout-placeholder" *ngFor="let workout of workoutsPlaceholder; let i = index">
    <div class="skeleton" style="height: 121px; width: 85%;"></div>
    <div class="skeleton" style="height: 28px; width: 15%; margin-left: 5px;"></div>
  </div>
</div>
<div class="container" *ngIf="!guiService.userLogged.workoutInfo.lastWorkoutHistory">
  <h2>{{"DIARY.WORKOUT-HISTORY" | translate}}</h2>
  <p class="no-content">{{"DIARY.NO-CONTENT" | translate}}</p>
</div>
